import './staticIntents';
import 'containers/Transactions/navigationIntent';
